import React from "react";
import {
    AccountsIcon,
    BankCheckIcon,
    AccountStatusIcon,
    AssigneeIcon,
    AttachIcon,
    CalendarIcon,
    CalendarDaysIcon,
    CalendarEndIcon,
    CalendarStartIcon,
    CategoryIcon,
    ChatIcon,
    CheckIcon,
    ClassIcon,
    DirectoryIcon,
    DocumentIcon,
    DollarCircleIcon,
    EditIcon,
    EntityTypeIcon,
    FolderIcon,
    GLIcon,
    GLAccrualIcon,
    GroupIcon,
    InfoIcon,
    RulesIcon,
    LinkIcon,
    LockIcon,
    MatchedIcon,
    ReceiptIcon,
    PercentageIcon,
    PriorityIcon,
    ProfileIcon,
    ReconciledIcon,
    ServicesIcon,
    SourceIcon,
    SplitSIcon,
    StatusIcon,
    SubscriptionIcon,
    TeamIcon,
    TemplatesIcon,
    WhoPaysIcon,
} from "@icons";
import { FilterTabs } from "./lib";

export const FilterTabIconMapping: Record<FilterTabs, React.ReactNode> = {
    [FilterTabs.CATEGORY]: <CategoryIcon />,
    [FilterTabs.DATE]: <CalendarIcon />,
    [FilterTabs.AMOUNT]: <DollarCircleIcon />,
    [FilterTabs.ACCOUNT]: <AccountsIcon />,
    [FilterTabs.RULES]: <RulesIcon />,
    [FilterTabs.SIMILAR_TO]: <RulesIcon />,
    [FilterTabs.CLASS]: <ClassIcon />,
    [FilterTabs.NOTE]: <EditIcon />,
    [FilterTabs.RECEIPTS]: <DocumentIcon />,
    [FilterTabs.MATCHED]: <LinkIcon />,
    [FilterTabs.SPLIT]: <SplitSIcon width={16} height={16} />,
    [FilterTabs.RECONCILIATION]: <ReconciledIcon />,
    [FilterTabs.CASH_ITEM_TYPE]: <BankCheckIcon />,
    [FilterTabs.COUNTERPARTY]: <DirectoryIcon />,
    [FilterTabs.COUNTERPARTY_CREATED_BY]: <ProfileIcon />,
    [FilterTabs.CUSTOMER]: <DirectoryIcon />,
    [FilterTabs.DOCUMENT_STATUS]: <StatusIcon />,
    [FilterTabs.DOCUMENT_CATEGORY]: <CategoryIcon />,
    [FilterTabs.ACCOUNT_CODE]: <GLIcon />,
    [FilterTabs.ACCOUNT_STATUS]: <AccountStatusIcon />,
    [FilterTabs.INVOICE_STATUSES]: <StatusIcon />,
    [FilterTabs.EXTERNAL_INVOICE_STATUSES]: <StatusIcon />,
    [FilterTabs.BILLABLE_EXPENSE_INVOICE_STATUSES]: <StatusIcon />,
    [FilterTabs.CATALOG_ITEM]: <ReceiptIcon />,
    [FilterTabs.INVOICE_SOURCE_TEMPLATE]: <TemplatesIcon />,
    [FilterTabs.SUBSCRIPTION]: <SubscriptionIcon />,
    [FilterTabs.BILL_STATUSES]: <StatusIcon />,
    [FilterTabs.EXTERNAL_BILL_STATUSES]: <StatusIcon />,
    [FilterTabs.OVERDUE]: <CalendarIcon />,
    [FilterTabs.DUE]: <CalendarIcon />,
    [FilterTabs.RULES_STATUS]: <StatusIcon />,
    [FilterTabs.RULES_SOURCE]: <SourceIcon />,
    [FilterTabs.RULES_ACTION]: <RulesIcon />,
    [FilterTabs.LEDGER]: <GLIcon />,
    [FilterTabs.CASH_GENERAL_LEDGER]: <GLIcon />,
    [FilterTabs.ACCRUAL_GENERAL_LEDGER]: <GLAccrualIcon />,
    [FilterTabs.ACCRUAL_LEDGER]: <GLAccrualIcon />,
    [FilterTabs.CATALOG_ITEM_INCOME_ACCOUNT]: <GLIcon />,
    [FilterTabs.CATALOG_ITEM_RECEIVABLES_ACCOUNT]: <GLAccrualIcon />,
    [FilterTabs.TRANSACTION_IDS]: <LinkIcon />,
    [FilterTabs.PLANS]: <DollarCircleIcon />,
    [FilterTabs.WHO_PAYS]: <WhoPaysIcon />,
    [FilterTabs.SERVICES]: <ServicesIcon />,
    [FilterTabs.TEAM_MEMBERS]: <TeamIcon />,
    [FilterTabs.ASSIGNEE]: <ProfileIcon />,
    [FilterTabs.LEGAL_TYPE]: <EntityTypeIcon />,
    [FilterTabs.ENTITY_INDUSTRY]: <ServicesIcon />,
    [FilterTabs.ENTITY_BASIS]: <GLIcon />,
    [FilterTabs.START_DATE]: <CalendarIcon />,
    [FilterTabs.CLOSE_STAGE]: <StatusIcon />,
    [FilterTabs.PRIORITY]: <PriorityIcon />,
    [FilterTabs.CLOSE_DATE]: <CalendarIcon />,
    [FilterTabs.DUE_DATE]: <CalendarIcon />,
    [FilterTabs.TRANSACTION_LOCKED]: <LockIcon />,
    [FilterTabs.ACCOUNT_SOURCE]: <SourceIcon />,
    [FilterTabs.ACCOUNT_ROLE_PRESENCE]: <RulesIcon />,
    [FilterTabs.ACCOUNT_RULE_PRESENCE]: <RulesIcon />,
    [FilterTabs.FORM_1099_BOX]: <RulesIcon />,
    [FilterTabs.COA_TEMPLATE_GROUPS]: <DirectoryIcon />,
    [FilterTabs.JOURNAL_ENTRY_SOURCES]: <SourceIcon />,
    [FilterTabs.UNREAD]: <CheckIcon />,
    [FilterTabs.DOCUMENT_PERIOD]: <CalendarIcon />,
    [FilterTabs.UPLOADER]: <ProfileIcon />,
    [FilterTabs.UPLOAD_DATE]: <CalendarIcon />,
    [FilterTabs.DOCUMENT_TYPE]: <DocumentIcon />,
    [FilterTabs.STATUS]: <StatusIcon />,
    [FilterTabs.MATCH_STATUS]: <MatchedIcon />,
    [FilterTabs.AUDIT_LOG]: <InfoIcon />,
    [FilterTabs.BILL_IDS]: <LinkIcon />,
    [FilterTabs.INVOICE_IDS]: <LinkIcon />,
    [FilterTabs.TEMPLATE_COUNTERPARTY]: <DirectoryIcon />,
    [FilterTabs.TEMPLATE_CUSTOMER]: <DirectoryIcon />,
    [FilterTabs.TEMPLATE_CLASS]: <ClassIcon />,
    [FilterTabs.TEMPLATE_BASIS]: <GLIcon />,
    [FilterTabs.TEMPLATE_LAST_EDITED_BY]: <ProfileIcon />,
    [FilterTabs.TEMPLATE_OWNER]: <ProfileIcon />,
    [FilterTabs.TEMPLATE_CREATED_BY]: <ProfileIcon />,
    [FilterTabs.TEMPLATE_TYPE]: <ServicesIcon />,
    [FilterTabs.TEMPLATE_IDS]: <LinkIcon />,
    [FilterTabs.TASK_ASSIGNEE]: <AssigneeIcon />,
    [FilterTabs.TASK_CREATED_BY]: <ProfileIcon />,
    [FilterTabs.TASK_CLIENT]: <DirectoryIcon />,
    [FilterTabs.TASK_CREATED_ON]: <CalendarIcon />,
    [FilterTabs.TASK_COMPLETED_BY]: <ProfileIcon />,
    [FilterTabs.TASK_COMPLETED_ON]: <CalendarIcon />,
    [FilterTabs.TASK_CLOSE]: <StatusIcon />,
    [FilterTabs.TASK_PRIORITY]: <PriorityIcon />,
    [FilterTabs.TASK_ATTACHMENTS]: <AttachIcon />,
    [FilterTabs.TASK_GROUP]: <GroupIcon />,
    [FilterTabs.TASK_DEPENDENCIES]: <LinkIcon />,
    [FilterTabs.TASK_CHAT]: <ChatIcon />,
    [FilterTabs.TASK_STAGE]: <StatusIcon />,
    [FilterTabs.ORG_TASK_TEMPLATE_TYPE]: <ServicesIcon />,
    [FilterTabs.ORG_TASK_TEMPLATE_GROUP]: <GroupIcon />,
    [FilterTabs.ORG_TASK_TEMPLATE_ASSIGNEE_ROLE]: <AssigneeIcon />,
    [FilterTabs.ORG_TASK_TEMPLATE_CREATED_BY]: <ProfileIcon />,
    [FilterTabs.ORG_CLOSE_STAGE]: <StatusIcon />,
    [FilterTabs.CLOSE_STATUS]: <CheckIcon />,
    [FilterTabs.ORG_SERVICE]: <ServicesIcon />,
    [FilterTabs.CLOSE_TEMPLATE]: <TemplatesIcon />,
    [FilterTabs.APPLICATION_TYPE]: <CheckIcon />,
    [FilterTabs.PROGRESS]: <PercentageIcon />,
    [FilterTabs.HEALTH]: <StatusIcon />,
    [FilterTabs.WORK_CLIENT]: <DirectoryIcon />,
    [FilterTabs.WORK_START_DATE]: <CalendarStartIcon />,
    [FilterTabs.WORK_DELIVERY_DATE]: <CalendarEndIcon />,
    [FilterTabs.APPLICATION_DATE]: <CalendarIcon />,
    [FilterTabs.COA_LAST_UPDATED]: <CalendarIcon />,
    [FilterTabs.COA_APPLIED_AT]: <CalendarIcon />,
    [FilterTabs.DAYS_IN_STAGE]: <CalendarDaysIcon />,
    [FilterTabs.REVIEW]: <CheckIcon />,
    [FilterTabs.RULES_REVIEW]: <CheckIcon />,
    [FilterTabs.COUNTERPARTY_REVIEW]: <CheckIcon />,
    [FilterTabs.COUNTERPARTY_DISABLED]: <AccountStatusIcon />,
    [FilterTabs.ENGAGEMENT_TEAM]: <TeamIcon />,
    [FilterTabs.ELIGIBLE_1099]: <DocumentIcon />,
    [FilterTabs.EXCLUDE_1099]: <DocumentIcon />,
    [FilterTabs.LEDGER_GROUP]: <FolderIcon />,
    [FilterTabs.SCHEDULE_PERIOD]: <CalendarDaysIcon />,
    [FilterTabs.SCHEDULE_TEMPLATE]: <TemplatesIcon />,
    [FilterTabs.SCHEDULE_CLIENT]: <DirectoryIcon />,
    [FilterTabs.SCHEDULES_REPORT_TEMPLATE]: <TemplatesIcon />,
    [FilterTabs.SCHEDULES_REPORT_GROUP]: <FolderIcon />,
    [FilterTabs.HOLDING_ACCOUNT]: <GLIcon />,
    [FilterTabs.TERM_START]: <CalendarStartIcon />,
    [FilterTabs.TERM_END]: <CalendarEndIcon />,
    [FilterTabs.INVOICE_TERMS]: <ReceiptIcon />,
    [FilterTabs.INVOICE_SENT_STATUS]: <ReceiptIcon />,
    [FilterTabs.INVOICE_CREATED_ON]: <CalendarIcon />,
    [FilterTabs.INVOICE_DUE_DATE]: <CalendarIcon />,
    [FilterTabs.INVOICE_DATE]: <CalendarIcon />,
    [FilterTabs.AGING_PERIOD]: <CalendarDaysIcon />,
    [FilterTabs.DRAFT_SOURCE]: <SourceIcon />,
    [FilterTabs.DRAFT_COUNTERPARTY]: <DirectoryIcon />,
    [FilterTabs.DRAFT_DUE_DATE]: <CalendarEndIcon />,
    [FilterTabs.DRAFT_STATUS]: <StatusIcon />,
};
